import axios from '../plugins/parseAxios'
export class ContractDocumentAPI {
    static getContractDocument(payload) {
        return axios.post("functions/getContractDocument", payload)
    }
    static getContractDocuments(payload) {
        return axios.post("functions/getContractDocuments", payload)
    }
    static updateContractDocument(payload) {
        return axios.post("functions/updateContractDocument", payload)
    }
    static removeContractDocument(payload) {
        return axios.post("functions/removeContractDocument", payload)
    }
    static createContractDocument(payload) {
        return axios.post("functions/createContractDocument", payload)
    }
    static createContractDocumentNoContract(payload) {
        return axios.post("functions/createContractDocumentNoContract", payload)
    }
    static getContractDocumentByContractIds(payload) {
        return axios.post("functions/getContractDocumentByContractIds", payload)
    }
}